import BaseModel from './BaseModel';

class BatteryTransaction extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.updateData(data)
    }

    updateData = (data) => {
        if (data.battery_swap) {
            this.battery_swap_id = data.battery_swap.id || '';
            this.battery_swap_charging_station_id = data.battery_swap.charging_station_id || '';
            this.battery_swap_status = data.battery_swap.status || '';
            this.battery_swap_charging_station_owner = data.battery_swap.charging_station_owner || '';
            if (data.details.swap_items) {
                this.swap_items = data.details.swap_items || [];
                this.battery_one_in_id = data.details.swap_items[0].in.id || '';
                this.battery_one_in_serial_number = data.details.swap_items[0].in.serial_number || '';
                this.battery_one_out_id = data.details.swap_items[0].out.id || '';
                this.battery_one_out_serial_number = data.details.swap_items[0].out.serial_no || '';
                this.battery_two_in_id = data.details.swap_items[1]?.in?.id || '';
                this.battery_two_in_serial_number = data.details.swap_items[1]?.in?.serial_number || '';
                this.battery_two_out_id = data.details.swap_items[1]?.out?.id || '';
                this.battery_two_out_serial_number = data.details.swap_items[1]?.out?.serial_no || '';
            }
        }
    }

    toApiJson = () => {
        return {
            id: this.id,
            battery_transaction: {
                battery_one_in_id: this.battery_one_in_id,
                battery_one_in_serial_number: this.battery_one_in_serial_number,
                battery_one_out_id: this.battery_one_out_id,
                battery_one_out_serial_number: this.battery_one_out_serial_number,
                battery_two_in_id: this.battery_two_in_id,
                battery_two_in_serial_number: this.battery_two_in_serial_number,
                battery_two_out_id: this.battery_two_out_id,
                battery_two_out_serial_number: this.battery_two_out_serial_number,
                battery_swap_id: this.battery_swap_id,
                battery_swap_charging_station_id: this.battery_swap_charging_station_id,
                battery_swap_status: this.battery_swap_status,
                battery_swap_charging_station_owner: this.battery_swap_charging_station_owner,
                swap_items: this.swap_items,
            }
        }
    }
}

export default BatteryTransaction;
